import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';
import { Modal } from '../components/Modal.jsx';

export default function Vat() {
  const { t } = useTranslation();
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['vat'], queryFn: () => api('/api/vat') });
  const [editing, setEditing] = useState(null);

  const save = useMutation({
    mutationFn: p => p.id
      ? api(`/api/vat/${p.id}`, { method: 'PATCH', body: p.data })
      : api('/api/vat', { method: 'POST', body: p.data }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['vat'] }); setEditing(null); },
  });

  return (
    <>
      <div className="page-header">
        <h1>{t('vat.title')}</h1>
        <button className="btn btn-primary" onClick={() => setEditing({})}>{t('vat.add')}</button>
      </div>
      <table className="table">
        <thead><tr><th>{t('common.name')}</th><th>{t('vat.rate')}</th><th>{t('vat.default')}</th><th>{t('common.active')}</th><th></th></tr></thead>
        <tbody>
          {data?.rates?.map(r => (
            <tr key={r.id}>
              <td>{r.name}</td><td>{Number(r.rate).toFixed(2)}%</td>
              <td>{r.isDefault ? '✓' : ''}</td>
              <td>{r.active ? t('common.yes') : t('common.no')}</td>
              <td><button className="btn btn-secondary btn-sm" onClick={() => setEditing(r)}>{t('common.edit')}</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {editing && <VatModal rate={editing} onClose={() => setEditing(null)} onSave={d => save.mutate({ id: editing.id, data: d })} saving={save.isPending} />}
    </>
  );
}

function VatModal({ rate, onClose, onSave, saving }) {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: rate.name || '',
    rate: rate.rate != null ? Number(rate.rate) : 18,
    isDefault: rate.isDefault ?? false,
    active: rate.active ?? true,
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  return (
    <Modal title={rate.id ? t('common.edit') : t('vat.add')} onClose={onClose}>
      <form onSubmit={e => { e.preventDefault(); onSave(form); }}>
        <div className="field"><label>{t('common.name')}</label><input required value={form.name} onChange={e => set('name', e.target.value)} /></div>
        <div className="field"><label>{t('vat.rate')}</label><input type="number" step="0.001" min={0} max={100} value={form.rate} onChange={e => set('rate', Number(e.target.value))} /></div>
        <div className="row">
          <div className="field"><label><input type="checkbox" checked={form.isDefault} onChange={e => set('isDefault', e.target.checked)} /> {t('vat.default')}</label></div>
          <div className="field"><label><input type="checkbox" checked={form.active} onChange={e => set('active', e.target.checked)} /> {t('common.active')}</label></div>
        </div>
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>{t('common.save')}</button>
        </div>
      </form>
    </Modal>
  );
}
